<template>
    <div class="page-table mainDiv haberTanim" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.popup.tanimlama.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="popupForm" :rules="rulesPopup" ref="popupForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.popup.tanimlama.baslik")'
                                                  prop="baslik">:
                                        <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                  v-model="popupForm.baslik"
                                                  :placeholder='$t("src.views.apps.popup.tanimlama.baslikPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.popup.tanimlama.link")'
                                                  prop="link">:
                                        <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                  v-model="popupForm.link"
                                                  :placeholder='$t("src.views.apps.popup.tanimlama.linkPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.popup.tanimlama.tarih")'
                                                  prop="tarih">:
                                        <el-date-picker
                                                style="width: 100%"
                                                v-model="popupForm.tarih"
                                                type="datetimerange"
                                                start-placeholder="Başlama Tarihi"
                                                end-placeholder="Bitiş Tarihi"
                                                format="yyyy-MM-dd HH:mm:ss"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                :default-time="['08:00:00', '17:00:00']">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.popup.tanimlama.icerik")'
                                                  prop="icerik">:
                                        <ckeditor @blur="$store.commit('changeTabsClose', false)" :editor="editor"
                                                  :config="editorConfig"
                                                  v-model="popupForm.icerik"></ckeditor>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <el-collapse class="animated fadeInUp" style="margin-top: 10px" v-model="activeCollapse">
                        <draggable
                                data-source="juju"
                                class="list-group"
                                group="a">
                            <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="4">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.popup.tanimlama.resim")'
                                                prop="image">:
                                            <el-upload
                                                    action=""
                                                    :auto-upload="false"
                                                    :limit="1"
                                                    accept=".jpg,.jpeg,.png"
                                                    ref="upload"
                                                    list-type="picture-card"
                                                    :on-change="imageUpload"
                                                    :on-remove="imageRemove">
                                                <i slot="default" class="el-icon-plus"></i>
                                            </el-upload>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item class="card-shadow--medium" name="1"
                                          :title='$t("src.views.apps.popup.tanimlama.durum")'>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="durum">
                                        <el-select v-on:change="$store.commit('changeTabsClose', false)"
                                                   v-model="popupForm.durum"
                                                   style="width: 100%">
                                            <el-option value="0" label="Pasif">Pasif</el-option>
                                            <el-option value="1" label="Aktif">Aktif</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-button
                                        size="mini" v-on:click="popupTanimlama('popupForm',popupForm.durum)"
                                        class="onayBtn"
                                        type="primary">
                                    {{$t('src.views.apps.popup.tanimlama.popupEkle')}}
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.yonetici.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('popupForm')">
                                            {{$t('src.views.apps.yonetici.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.yonetici.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.yonetici.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip content='Çöp Kutusuna At' :open-delay="500" placement="bottom">
                                    <el-button class="cop" v-on:click="popupTanimlama('popupForm','0')" type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.popup.tanimlama.gorunum")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="gorunum">
                                            <el-switch
                                                    v-model="popupForm.gorunum"
                                                    active-value="1"
                                                    inactive-value="0"
                                                    active-text="Tüm Sayfalar"
                                                    inactive-text="Anasayfa">
                                            </el-switch>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.popup.tanimlama.gorunumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.popup.tanimlama.otomatik")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="otomatik">
                                            <el-switch
                                                    v-model="popupForm.otomatik"
                                                    active-value="1"
                                                    inactive-value="0"
                                                    active-text="Otomatik"
                                                    inactive-text="Manuel">
                                            </el-switch>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.popup.tanimlama.otomatikAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
    import JQuery from 'jquery';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import draggable from 'vuedraggable'
    let $ = JQuery;
    import popupService from '../../../WSProvider/PopService'
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataSidas = "";
    export default {
        name: "PopupTanimla",
        components: {
            draggable,
        },
        mounted() {
            if (localStorage.getItem("userDataSidas")) {
                userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
            }
        },
        data() {
            return {
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },

                visibleSil: false,
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                popupForm: {
                    baslik: '',
                    icerik: '',
                    image: '',
                    imageBase: '',
                    link: '',
                    tarih: '',
                    durum: '1',
                    gorunum: '0',
                    otomatik: '1',
                },
                rulesPopup: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Giriniz",
                        trigger: 'blur'
                    }],
                    tarih: [{
                        required: true,
                        message: "Lütfen Tarih Giriniz",
                        trigger: 'blur'
                    }]
                },
            }
        },

        methods: {
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
            },
            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.popupForm.baslik) {
                        var imgname = randomText(7) + '-' +linkTemizle(this.popupForm.baslik) + ".png";
                    } else {
                        imgname = randomText(7) + '-' +linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                    }
                    this.popupForm.image = imgname;
                    const files = file.raw;
                    if (files) {
                        const reader = new FileReader();
                        reader.onload = e => {
                            this.popupForm.imageBase = e.target.result;
                        };
                        reader.readAsDataURL(files);
                    }
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageRemove() {
                $('.el-upload--picture-card').show();
            },
            popupTanimlama(formName, durum) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.popupForm.tarih) {
                            var baslamaTarihi = this.popupForm.tarih[0];
                            var bitisTarihi = this.popupForm.tarih[1];
                        }
                        popupService.popTanimlama(this.popupForm.baslik, this.popupForm.icerik, this.popupForm.image, this.popupForm.imageBase, this.popupForm.link, this.popupForm.otomatik, baslamaTarihi, bitisTarihi, this.popupForm.gorunum, this.popupForm.durum).then((response) => {
                            if (response.status === 200) {
                                if (durum === '0') {
                                    notification.Status('success', this, 'Pop-Up arşive kaldırıldı.');

                                } else {
                                    notification.Status('success', this, 'Pop-Up başarıyla eklendi.');
                                }
                                this.$refs[formName].resetFields();
                                $('.el-upload-list__item-delete').click();
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir Pop-Up zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })

            }
        }

    }
    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return bugun + "-" + text;
    }
</script>

<style scoped>
    .upload-demo ul {
        margin: 0;
        padding: 0;
        list-style: none;
        background: aliceblue;
        width: 50%;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }


    .el-tag + .el-tag {
        margin-left: 10px;
    }

    #affix-container.haberTanim {
        /*position: relative;*/
        /*padding-left: 55px;*/
        /*left: -30px;*/
    }


</style>